import { createAction } from "redux-actions";
import { SET_ERROR_LOG, REQUEST_FAIL } from "./actionTypes";
import { createErrorLog } from "../../services/fetch";

export const setErrorLog = createAction(SET_ERROR_LOG);
export const requestFail = createAction(REQUEST_FAIL);

export const sendErrorLog = (message, statusCode, apiType = 'firebase', url) => (dispatch) => {
  createErrorLog(`/v1/logs/errors`, {message, statusCode, apiType, ...(url && {url})})
    .then((res) => {
      return dispatch(setErrorLog(res));
    })
    .catch((err) => dispatch(requestFail(err)));
};
export const sendSigninAttemptLog = ({ email, status, failureReason = '', type }) => (dispatch) => {
  createErrorLog(`/v1/logs/sign-ins`, { email, status, failureReason, type })
    .then((res) => {
      return res;
    })
    .catch((err) => dispatch(requestFail(err)));
};

export const sendAuthEvent = (eventType, { email, sessionId, errorCode, errorMessage, challengeCount } = {}) => (dispatch) => {
  createErrorLog(`/v1/logs/auth-events`, {
    eventType,
    ...(email && { email }),
    ...(sessionId && { sessionId }),
    // the API schema types errorCode as a string; a bare HTTP status would 422
    ...(errorCode != null && errorCode !== '' && { errorCode: String(errorCode) }),
    ...(errorMessage && { errorMessage }),
    ...(challengeCount !== undefined && { challengeCount }),
  })
    .then((res) => res)
    .catch((err) => dispatch(requestFail(err)));
};
